import React from "react";
import StarRating from "../../../StarRating/starrating";
import { useTranslation } from "react-i18next";
import "./styles.css";

const MobileHotelPopup = ({ hotel, onClose, onViewDetails }) => {
  const { t } = useTranslation();

  if (!hotel) return null;

  return (
    <div className="mobile-hotel-popup-overlay">
      <div className="mobile-hotel-popup">
        <button className="mobile-hotel-popup-close" onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <div className="mobile-hotel-popup-content">
          {/* Hotel image */}
          {hotel.DefaultImage?.FullSize && (
            <div className="mobile-hotel-popup-image">
              <img src={hotel.DefaultImage.FullSize} alt={hotel.DisplayName} />
            </div>
          )}

          {/* Hotel info */}
          <div className="mobile-hotel-popup-info">
            <div className="tw-mb-1">
              <StarRating rating={hotel.StarRating} />
            </div>

            <h3 className="mobile-hotel-popup-title">{hotel.DisplayName}</h3>

            <div className="mobile-hotel-popup-address">{hotel.Address}</div>

            {hotel.distance && (
              <div className="mobile-hotel-popup-distance">
                {hotel.distance.toFixed(2)} ק"מ מהיעד
              </div>
            )}

            {/* Price info */}
            {hotel.LowestPackagePrice && (
              <div className="mobile-hotel-popup-price">
                <div className="mobile-hotel-popup-price-label">החל מ:</div>
                <div className="mobile-hotel-popup-price-value">
                  ₪{hotel.LowestPackagePrice.toFixed(2)}
                </div>
              </div>
            )}

            {/* View details button */}
            <button
              className="mobile-hotel-popup-button"
              onClick={onViewDetails}
            >
              {t("hotelprofile.viewdetails") || "לפרטים נוספים"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileHotelPopup;
